(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = function(cents){
    try { return new Intl.NumberFormat('ar-EG',{style:'currency',currency:(window.RM && RM.currency)||'EGP',maximumFractionDigits:0}).format(cents/100); }
    catch(e){ return Math.round(cents/100) + ' ج.م'; }
  };

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) toggle.addEventListener('click', function(){
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
    toggle.querySelector('.ms').textContent = open ? 'close' : 'menu';
  });

  /* Toast */
  var toastTimer;
  function toast(title, msg, isError){
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.classList.toggle('is-error', !!isError);
    t.querySelector('.ms').textContent = isError ? 'error' : 'check_circle';
    t.querySelector('strong').textContent = title;
    t.querySelector('span:not(.ms)').innerHTML = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('is-on'); }, 3200);
  }

  /* ---------- Side cart (drawer) ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;
  function esc(t){ var d=document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function sized(url, w){ if(!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function paintCounts(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-total]').forEach(function(el){ el.textContent = fmt(cart.total_price); });
  }

  function renderDrawer(cart, newKey){
    paintCounts(cart);
    if (!drawer) return;
    var list = drawer.querySelector('[data-drawer-items]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    var ship = drawer.querySelector('[data-drawer-ship]');
    var cnt = drawer.querySelector('[data-drawer-count]');
    if (cnt) cnt.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.item_count){
      list.innerHTML = '<div class="rm-drawer__empty"><span class="ms" aria-hidden="true">shopping_bag</span><p>سلتك فارغة حالياً</p><a class="rm-btn rm-btn--primary" href="' + root + 'collections/all">تصفح الروايات</a></div>';
      foot.hidden = true; if (ship) ship.hidden = true; return;
    }
    foot.hidden = false;
    var th = (window.RM && RM.freeShip) || 0;
    if (ship && th > 0){
      ship.hidden = false;
      var left = th - cart.total_price, pct = Math.min(100, Math.round(cart.total_price * 100 / th));
      ship.innerHTML = (left > 0 ? 'أضف <strong>' + fmt(left) + '</strong> لتحصل على شحن مجاني' : '<strong>مبروك!</strong> طلبك مؤهل للشحن المجاني') +
        '<span class="rm-drawer__bar"><i style="width:' + pct + '%"></i></span>';
    }
    list.innerHTML = cart.items.map(function(it, i){
      var line = i + 1;
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<small>' + esc(it.variant_title) + '</small>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '';
      return '<div class="rm-drawer__item' + (it.key === newKey ? ' is-new' : '') + '">' +
        '<a class="rm-drawer__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="rm-drawer__info">' +
          '<a class="rm-drawer__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="rm-drawer__row">' +
            '<div class="rm-qty rm-qty--sm">' +
              '<button type="button" data-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="زيادة الكمية">+</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="تقليل الكمية">−</button>' +
            '</div>' +
            '<span class="rm-drawer__price">' + was + fmt(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="rm-drawer__remove" data-line="' + line + '" data-q="0" aria-label="حذف ' + esc(it.product_title) + '"><span class="ms" aria-hidden="true">delete</span></button>' +
      '</div>';
    }).join('');
    drawer.querySelector('[data-drawer-subtotal]').textContent = fmt(cart.total_price);
    var n = list.querySelector('.is-new'); if (n) n.scrollIntoView({block:'nearest'});
    loadDrawerRecs(cart);
  }

  /* Upsell inside the cart drawer: "complete your order" */
  var recsFor = null;
  function loadDrawerRecs(cart){
    var box = drawer && drawer.querySelector('[data-drawer-recs]');
    if (!box) return;
    if (!cart.items.length) { box.hidden = true; return; }
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function(i){ return i.product_id; });
    if (recsFor === pid + ':' + inCart.join(',')) return;
    recsFor = pid + ':' + inCart.join(',');
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(d){
        var list = (d.products || []).filter(function(p){ return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 3);
        if (!list.length) { box.hidden = true; return; }
        box.innerHTML = '<h3>أكمل طلبك</h3>' + list.map(function(p){
          var v = (p.variants || []).filter(function(x){ return x.available; })[0] || p.variants[0];
          var img = p.featured_image ? sized(p.featured_image, 120) : '';
          return '<div class="rm-drawer__rec">' +
            '<a href="' + esc(p.url) + '" class="rm-drawer__rec-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div><a href="' + esc(p.url) + '" class="rm-drawer__rec-title">' + esc(p.title) + '</a><span>' + fmt(v.price) + '</span></div>' +
            '<button type="button" class="rm-btn rm-btn--outline" data-quick-add="' + v.id + '" aria-label="أضف ' + esc(p.title) + ' للسلة"><span class="ms" aria-hidden="true">add</span></button>' +
          '</div>';
        }).join('');
        box.hidden = false;
      }).catch(function(){ box.hidden = true; });
  }

  function addItems(items){
    return fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
      .then(function(res){
        if (!res.ok) { toast('تعذّرت الإضافة', (res.d && res.d.description) || 'حاول مرة أخرى.', true); return; }
        var key = res.d.items && res.d.items[0] && res.d.items[0].key;
        return loadCart(key).then(function(){ openDrawer(); });
      })
      .catch(function(){ toast('تعذّرت الإضافة', 'تحقق من الاتصال وحاول مرة أخرى.', true); });
  }

  /* Quick add buttons (drawer upsell) */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    b.disabled = true;
    addItems([{id: +b.getAttribute('data-quick-add'), quantity: 1}]).finally(function(){ b.disabled = false; });
  });

  /* Frequently bought together */
  document.querySelectorAll('[data-fbt]').forEach(function(box){
    var boxes = box.querySelectorAll('[data-fbt-item]');
    var total = box.querySelector('[data-fbt-total]'), count = box.querySelector('[data-fbt-count]'), btn = box.querySelector('[data-fbt-add]');
    function sum(){
      var t = 0, n = 0;
      boxes.forEach(function(c){ if (c.checked) { t += +c.getAttribute('data-price'); n++; } });
      total.textContent = fmt(t); count.textContent = n;
    }
    boxes.forEach(function(c){ c.addEventListener('change', sum); });
    sum();
    btn.addEventListener('click', function(){
      var items = [];
      boxes.forEach(function(c){ if (c.checked) items.push({id: +c.getAttribute('data-id'), quantity: 1}); });
      btn.disabled = true; btn.classList.add('is-loading');
      addItems(items).finally(function(){ btn.disabled = false; btn.classList.remove('is-loading'); });
    });
  });

  /* Shopify product recommendations section */
  document.querySelectorAll('[data-recs]').forEach(function(sec){
    fetch(sec.getAttribute('data-url')).then(function(r){ return r.ok ? r.text() : ''; }).then(function(html){
      if (!html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var grid = tmp.querySelector('.rm-grid');
      if (!grid || !grid.children.length) return;
      sec.querySelector('[data-recs-target]').appendChild(grid);
      sec.hidden = false;
      if (typeof paintWish === 'function') paintWish();
    }).catch(function(){});
  });

  function openDrawer(){
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('rm-lock');
    var panel = drawer.querySelector('[data-drawer-panel]'); if (panel) setTimeout(function(){ panel.focus(); }, 50);
    return true;
  }
  function closeDrawer(){
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('rm-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function loadCart(newKey){
    return fetch(root + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderDrawer(c, newKey); return c; });
  }

  if (drawer){
    drawer.addEventListener('click', function(e){
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      var b = e.target.closest('[data-line]');
      if (!b) return;
      drawer.classList.add('is-busy');
      fetch(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({line: +b.getAttribute('data-line'), quantity: Math.max(0, +b.getAttribute('data-q'))})})
        .then(function(r){ return r.json(); })
        .then(function(c){ if (c && c.items) renderDrawer(c); else toast('تعذّر التحديث', (c && c.description) || 'حاول مرة أخرى.', true); })
        .catch(function(){ toast('تعذّر التحديث', 'تحقق من الاتصال وحاول مرة أخرى.', true); })
        .finally(function(){ drawer.classList.remove('is-busy'); });
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeDrawer(); });
    document.addEventListener('click', function(e){
      var a = e.target.closest('[data-cart-open]');
      if (!a || document.body.classList.contains('template-cart')) return;
      e.preventDefault(); loadCart(); openDrawer();
    });
  }

  /* AJAX add to cart for every product form */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
      .then(function(res){
        if (!res.ok) { toast('تعذّرت الإضافة', res.d.description || 'حاول مرة أخرى.', true); return; }
        var key = res.d.key || (res.d.items && res.d.items[0] && res.d.items[0].key);
        return loadCart(key).then(function(){
          if (!openDrawer()) toast('تمت الإضافة إلى السلة', '<a href="' + root + 'cart">اذهب إلى السلة لإتمام الطلب</a>');
        });
      })
      .catch(function(){ toast('تعذّرت الإضافة', 'تحقق من الاتصال وحاول مرة أخرى.', true); })
      .finally(function(){ if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });

  /* ---------- Search: products only, optional category ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-search-form]');
    if (!form) return;
    var input = form.querySelector('[data-search-input]');
    var sel = form.querySelector('[data-search-cat]');
    var term = input ? input.value.trim() : '';
    var opt = sel && sel.value ? sel.options[sel.selectedIndex] : null;
    if (!opt) { if (!term) { e.preventDefault(); input && input.focus(); } return; }
    if (!term) { e.preventDefault(); window.location.href = opt.getAttribute('data-url'); return; }
    e.preventDefault();
    var q = term + ' tag:"' + sel.value.replace(/"/g, '') + '"';
    var params = new URLSearchParams({q: q, type: 'product', 'options[prefix]': 'last'});
    window.location.href = form.getAttribute('action') + '?' + params.toString();
  });

  /* Wishlist (saved in this browser) */
  var KEY = 'rm-wishlist';
  function getWish(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function setWish(list){ try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){} }
  function paintWish(){
    var list = getWish();
    document.querySelectorAll('[data-wish]').forEach(function(b){
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    document.querySelectorAll('[data-wish-count]').forEach(function(el){ el.textContent = list.length; el.hidden = list.length === 0; });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), list = getWish(), i = list.indexOf(h);
    if (i > -1) { list.splice(i,1); } else { list.push(h); toast('أُضيفت إلى المفضلة', 'تجدها في صفحة المفضلة أعلى الموقع.'); }
    setWish(list); paintWish();
  });
  paintWish();

  /* Wishlist page */
  var wishGrid = document.querySelector('[data-wish-grid]');
  if (wishGrid) {
    var list = getWish();
    if (!list.length) { document.querySelector('[data-wish-empty]').hidden = false; }
    else {
      Promise.all(list.map(function(h){
        return fetch(root + 'products/' + h + '?view=rm-card').then(function(r){ return r.ok ? r.text() : ''; });
      })).then(function(html){ wishGrid.innerHTML = html.join(''); paintWish(); });
    }
  }

  /* Quantity steppers */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), v);
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  /* Product page variants */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var data = JSON.parse(pdp.querySelector('[data-variants]').textContent);
    var idInput = pdp.querySelector('input[name=id]');
    var addBtn = pdp.querySelector('[data-add-btn]');
    function update(){
      var chosen = [];
      pdp.querySelectorAll('[data-option-group]').forEach(function(g){
        var c = g.querySelector('input:checked'); chosen.push(c ? c.value : null);
      });
      var v = data.find(function(x){ return x.options.every(function(o,i){ return o === chosen[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      pdp.querySelector('[data-price]').textContent = fmt(v.price);
      var was = pdp.querySelector('[data-compare]');
      if (was) { was.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; }
      addBtn.disabled = !v.available;
      addBtn.querySelector('[data-add-label]').textContent = v.available ? 'أضف إلى السلة' : 'نفدت الكمية';
      var st = pdp.querySelector('[data-stock]');
      if (st) { st.className = 'rm-stock ' + (v.available ? 'ok' : 'no'); st.lastChild.textContent = v.available ? ' متوفر للشحن الفوري' : ' غير متوفر حالياً'; }
      if (v.featured_image) { var m = pdp.querySelector('[data-main-wrap] img'); if (m) { m.src = v.featured_image; m.removeAttribute('srcset'); } }
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    pdp.querySelectorAll('[data-option-group] input').forEach(function(i){ i.addEventListener('change', update); });
    pdp.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        var m = pdp.querySelector('[data-main-wrap] img');
        m.src = t.getAttribute('data-thumb'); m.removeAttribute('srcset');
        pdp.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* Box-set tabs */
  document.querySelectorAll('[data-tabs]').forEach(function(wrap){
    var section = wrap.closest('section');
    wrap.addEventListener('click', function(e){
      var t = e.target.closest('[data-tab]');
      if (!t) return;
      wrap.querySelectorAll('[data-tab]').forEach(function(x){ x.classList.toggle('is-active', x === t); x.setAttribute('aria-pressed', x === t); });
      var key = t.getAttribute('data-tab');
      section.querySelectorAll('[data-group]').forEach(function(c){ c.hidden = key !== 'all' && c.getAttribute('data-group') !== key; });
    });
  });

  /* Collection filters + sort */
  var ft = document.querySelector('[data-filters-toggle]');
  if (ft) ft.addEventListener('click', function(){ document.querySelector('[data-filters]').classList.toggle('is-open'); });
  var ff = document.querySelector('[data-filter-form]');
  if (ff) ff.addEventListener('change', function(e){ if (e.target.type === 'checkbox' || e.target.name === 'sort_by') ff.submit(); });
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function(){
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u.toString();
  });

  /* Cart page: auto-submit qty changes */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) cartForm.addEventListener('change', function(e){ if (e.target.name === 'updates[]') cartForm.submit(); });
})();
